import TeamMembersList from "../components/TeamMembersList";
import React from "react";
import { NotificationPanel } from "../TeamDetails/NotificationPanel";
import { JoinCodePanel } from "../components/JoinCodePanel";
import { Team } from "../types";
import Causes from "../../../components/Causes";
import { DaySelect } from "./DaySelect";

type TeamDetailsAddProps = {
  selectedTeam: Team;
  organizationId: string | null | undefined;
  onNotificationsChange: (selectedValues: string[]) => void;
  selectedNotifications: string[];
  reportDay: string;
};

export const TeamView = ({
  selectedTeam,
  organizationId,
  selectedNotifications,
  reportDay,
}: TeamDetailsAddProps) => {
  return (
    <>
      <span className="secondary-title">Check-In Days</span>
      <NotificationPanel selectedNotificationDays={selectedNotifications} />
      <span className="secondary-title">Join code</span>
      <JoinCodePanel team={selectedTeam} organizationId={organizationId} />
      <span className="secondary-title">Members</span>
      <TeamMembersList teamId={selectedTeam.id} />
      <span className="secondary-title">Causes</span>
      <Causes
        teamScopeId={selectedTeam.id}
        selectedCauseTypeIds={selectedTeam.causeTypeIds}
        view={true}
      />
      <span className="secondary-title">Report day</span>
      <DaySelect reportDay={reportDay} />
    </>
  );
};
